import React from "react"
import { RecoilRoot } from 'recoil'
import ErrorBoundary from './ErrorBoundary'

const RecoilWrapper = (props) => {
  const { component: Component, componentProps } = props

  return (
    <ErrorBoundary>
      <RecoilRoot>
        {Component && <Component {...componentProps} />}
      </RecoilRoot>
    </ErrorBoundary>
  )
}

export default RecoilWrapper 